import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DateTimePicker from "@mui/lab/DateTimePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import TextField from "@mui/material/TextField";
import axios from "axios";
import moment from "moment";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import ReactPlayer from "react-player";
import swal from "sweetalert";
import StarProfileRightContent from "../../StarCardComponent/StarProfileRightContent/StarProfileRightContent";
import "./Greeting.css";
import { Markup } from "interweave";
import NodataAvailable from "../../../Common/NodataAvailable";
import { serverInfo } from "../../../../App";
import Loader from "../../../../Screen/Loader";
import ContentLoader from "../../../../Screen/ContentLoader";
import { LocationContext } from "../../../../CustomHelper/Helper";
import MyVerticallyCenteredModal from "../../../RegisterLearningDetails/RegisterNowPay/MyVerticallyCenteredModal";
import AutoSuggestionInput from "../../../Common/AutoSuggestionInput";

const Greeting = ({ star_id }) => {
  const { videoCdnUrl } = useContext(serverInfo);
  const [isMounted, setIsMounted] = useState(true);
  const [greetingText, setGreetingText] = useState("");
  const [loading, setloading] = useState(true);
  const [startTime, setStartTime] = useState(new Date());
  const [greeting, setGreeting] = useState(null);
  const [startMinDate, setStartMinDate] = useState(new Date());
  const [isStarGiveGreeting, setIsStarGiveGreeting] = useState(false);
  const [purposeList, setPurposeList] = useState([]);
  const [greetingTextTypeList, setGreetingTextTypeList] = useState([]);
  const [choosePurpose, setChoosePurposeMsg] = useState("");
  const [chooseName, setChooseNameMsg] = useState("");
  // const [greetingTextMsg, setGreetingTextMsg] = useState("");
  const [greetingName, setGreetingName] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [suggestionWord, setSuggestionWord] = useState('');
  const textAreaRef = useRef(null);
  const [GreetingInfo, setGreetingInfo] = useState({});
  const [star, setStar] = useState({});

  const { slectedCurrency, payStatus } = useContext(LocationContext);
  const [countryBaseCost, setCountryBaseCost] = useState(false);

  let d = new Date();

  const [inputData, setInputData] = useState({
    purpose: "",
    // greeting_text: null,
    // greeting_text: "",
    name: "",
    additional_message: "",
    error_list: [],
  });
  // console.log(inputData)
  useEffect(() => {
    getPurposeList();
    StarGreetingsStatus();
    GreetingsRegStatus();
  }, [star_id]);

  // normal Input
  const handleInput = (e) => {
    e.persist();
    let dataMerge = { ...inputData, [e.target.name]: e.target.value };
    // if (e.target.name === "purpose") {
    //   if (e.target.value != "") {
    //     setGreetingTextTypeList(getGreetingsTextType(e.target.value));
    //   } else {
    //     setGreetingTextMsg("");
    //   }
    //   dataMerge.greeting_text = "";
    // }
    setInputData(dataMerge);
  };

  const GreetingsRegStatus = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .get(`/api/user/greetings_registaion_status/${star_id}`)
        .then((res) => {
          if (res.data.status === 200) {
            setGreeting(res.data.greeting);
            setInputData({
              ...inputData,
              purpose: res?.data?.greeting?.purpose ?? "",
              // greeting_text: res?.data?.greeting?.greeting_context ?? "",
              additional_message: res?.data?.greeting?.additional_message ?? "",
              name: res?.data?.greeting?.name ?? "",
            });
            // console.log(JSON.parse(res?.data?.greeting?.greeting_context))
            // setGreetingTextTypeList(JSON.parse(res?.data?.greeting?.greeting_context) ?? []);
          } else {
            swal("error", "Data base Error", "error");
          }
        });
    });
  };

  const getPurposeList = () => {
    setloading(true);
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get(`/api/user/greetings/get_purpose_list`).then((res) => {
        if (res.data.status === 200) {
          setPurposeList(res?.data?.greetingTypes);
          // setGreetingTextTypeList(getGreetingsTextType(e.target.value));
          // console.log(res.data?.greetingTypes)
        } else {
          swal("error", "Data base Error", "error");
        }
        setloading(false);
      });
    });
  };

  const getPurposeTxt = (purpose) => {
    let plTxt = purposeList.filter((item) => item.greeting_type === purpose)[0]
      ?.greeting_text;
    plTxt = plTxt ? plTxt : "";
    return plTxt;
  };

  // const getGreetingsTextType = (purposeTxt) => {
  //   const purpose = purposeList?.find(
  //     (item) => item?.greeting_type === purposeTxt
  //   );
  //   return JSON.parse(purpose?.greeting_text) ?? [];
  // };
  // console.log(inputData?.greeting_text)
  const StarGreetingsStatus = () => {
    setloading(true);
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get("/api/user/greetings_star_status/" + star_id).then((res) => {
        // setloading(false);
        if (res.data.status === 200) {
          setStar(res.data.star);
          setIsStarGiveGreeting(res.data.action);
          setGreetingInfo(res.data.greeting);
          if (
            Number(res.data?.greeting?.user_required_day) != null &&
            Number(res.data?.greeting?.user_required_day) > 0
          ) {
            d.setDate(
              d.getDate() + Number(res.data?.greeting?.user_required_day)
            );
            setStartMinDate(d);
            setStartTime(d);
          }
          setloading(false);
        } else {
          swal("error", "Data base Error", "error");
        }
      });
    });
  };


  function handelTimeSubmit(e) {
    // setcheck(true)
    e.preventDefault();
    // else if (
    //   inputData.greeting_text === "" ||
    //   inputData.greeting_text === null
    // ) {
    //   setGreetingTextMsg("Choose Wishbox");
    // }
    let Form_data = new FormData(e.target);
    Form_data.append("time", moment(startTime));
    Form_data.append("greetings_id", GreetingInfo.id);
    Form_data.append("additional_message", inputData.additional_message);
    if (inputData.purpose === "" || inputData.purpose === null) {
      setChoosePurposeMsg("Choose Greeting Purpose");
    } else if (inputData.name === "" || inputData.name === null) {
      setChooseNameMsg("Name is required");
    } else {
      axios.get("/sanctum/csrf-cookie").then((response) => {
        axios.post(`/api/user/greetings/register`, Form_data).then((res) => {
          if (res.data.status === 200) {
            setGreeting(res.data.greeting);
            setModalShow(true);
            // setcheck(true)

            //document.getElementById('input_form').reset();
            // setGreetingTextMsg("");
            setChoosePurposeMsg("");
            setChooseNameMsg("");
            // swal("Success", res.data.message, "success");
          } else if (res.data.status === 422) {
            setInputData({
              ...inputData,
              error_list: res.data.validation_errors,
            });
          } else {
            setChoosePurposeMsg("Choose Greeting Purpose");
          }
        });
      });
    }
  }

  /**
   * delete register grettings
   */
  let handelGreetingsRegDelete = () => {
    swal({
      title: "Are you sure?",
      text: "You Want to Delete your Greetings",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axios.get("/sanctum/csrf-cookie").then((response) => {
          axios
            .get("api/user/greetings_reg_delete/" + greeting.id)
            .then((res) => {
              if (res.data.status === 200) {
                GreetingsRegStatus();
                swal("Your Greetings is Delete", {
                  icon: "success",
                });
              } else {
                swal("error", "hello", "error");
              }
            });
        });
      } else {
        // swal("Your Greetings is safe!");
      }
    });
  };

  useEffect(() => {
    setIsMounted(true);

    setCountryBaseCost(
      (
        Number(GreetingInfo?.cost) * Number(slectedCurrency?.currency_value)
      ).toFixed(0)
    );

    return () => {
      setIsMounted(false);
    };
  }, [GreetingInfo, slectedCurrency, isMounted]);
  const getUserFriendlyMessage = (status) => {
    switch (Number(status)) {
      case 0:
        return "Pending";
      case 1:
        return "Submitted";
      case 2:
        return "Greeting ready";
      case 3:
        return "Greeting ready";
      case 4:
        return "Greeting delivered";
      default:
        return null;
    }
  };

  const userMessage = getUserFriendlyMessage(greeting?.status);
  return (
    <>
      {loading === true ? (
        <ContentLoader />
      ) : (
        <>
          <div className="container StarContainer">
            <div className="row">
              <div className="col-md-8 mt-3 TabeStar">
                {isStarGiveGreeting === true ? (
                  <>
                    <div className="my-4 mx-auto">
                      <div className="card-bg1 rounded-3">
                        <div className="d-flex justify-content-center">
                          <i className="fa-solid fa-handshake handShakeIcon py-1 mx-2"></i>
                          <h3 className="text-warning text-center p-2">
                            Greeting Request
                          </h3>

                          {/* <p className="btn-warning btn-sm">Demo video</p> */}
                        </div>
                        <div className="star-line"></div>

                        <div className="container-fluid d-flex justify-content-center m-2">
                          <ReactPlayer
                            url={
                              GreetingInfo.video != null
                                ? videoCdnUrl + GreetingInfo?.video
                                : "https://youtu.be/dgfTiONcnTc"
                            }
                            controls
                            playing={false}
                            volume={1}
                            width="90%"
                            height="320px"
                            style={{
                              margin: "0 auto",
                              border: "1px dashed #ffad00",
                              borderRadius: "15px",
                              overflow: "hidden",
                              margin: "1rem 0",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    {GreetingInfo ? (
                      <>
                        <div className="card card-bg1">
                          <div className="card-body ">
                            <h5 className="text-light pb-3">
                              {GreetingInfo.title}
                            </h5>

                            <h5 className="text-warning">Instruction</h5>
                            <div className="under-line"></div>
                            <p className="text-light mt-2">
                              <Markup content={GreetingInfo.instruction} />
                            </p>

                            {/* <h5 className="text-warning">Description</h5>
                  <div className="under-line"></div>
                  <p className="text-light mt-2">
                    <Markup content={GreetingInfo.description} />
                  </p> */}

                            <div className="row">
                              <div className="col-md-6  ">
                                <div className="card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                                  <h5 className="text-warning pt-2 ">Cost</h5>
                                  <p className="text-light fw-bold pt-2">
                                    {countryBaseCost +
                                      " " +
                                      slectedCurrency?.symbol}
                                  </p>
                                </div>
                              </div>
                              <div className="col-md-6 ">
                                <div className="card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                                  <h5 className="text-warning pt-2 ">
                                    {" "}
                                    Minimum apply before
                                  </h5>
                                  <p className="text-light fw-bold pt-2">
                                    {GreetingInfo?.user_required_day} Day
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}

                    <div className="card-bg1 rounded-3">
                      <div className=" my-4 mx-auto">
                        <div className="">
                          <div className="d-flex justify-content-between">
                            <h5 className="text-warning p-3 mx-3">Apply</h5>
                            {greeting ? (
                              <div className="dropdown me-2 buttonBorderNone">
                                <button
                                  className="btn btn-secondary dropdown-toggle  "
                                  type="button"
                                  id="dropdownMenuButton1"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <i className="fas fa-info text-warning mx-2"></i>
                                </button>
                                <div
                                  className="dropdown-menu upperSideNotification"
                                  aria-labelledby="dropdownMenuButton1"
                                >
                                  <div className="p-3">
                                    <h4 className="text-white p-3 mx-3">
                                      Greeting Request
                                    </h4>
                                    <ul className="d-flex my-2">
                                      <div className="">
                                        <li>Applied on :</li>
                                        <li>Target date :</li>
                                        <li>Status :</li>
                                      </div>
                                      <div className="ms-2">
                                        <li>
                                          {moment(greeting.created_at).format(
                                            "D MMMM YYYY"
                                          )}
                                        </li>
                                        <li>
                                          {moment(greeting.request_time).format(
                                            "D MMMM YYYY"
                                          )}
                                        </li>
                                        <li>
                                          {userMessage && (
                                            <span>{userMessage}</span>
                                          )}
                                        </li>
                                      </div>
                                    </ul>

                                    {greeting.payment_status !== 1 && (
                                      <>
                                        <div className="text-warning text-center mt-2">
                                          Please complete your payment to
                                          proceed with the greetings process.
                                        </div>

                                        <div className="d-flex justify-content-between mt-4 mb-3 gap-1">
                                          <button
                                            className="btn btn-warning ms-4"
                                            onClick={() => setModalShow(true)}
                                          >
                                            <i className="fas fa-redo-alt"></i>{" "}
                                            Retry Payment
                                          </button>
                                          <button
                                            className="btn btn-warning me-4"
                                            onClick={handelGreetingsRegDelete}
                                          >
                                            <i className="fas fa-trash-alt"></i>{" "}
                                            Delete
                                          </button>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="star-line"></div>
                          <h5 className="m-3 text-light">
                            Greeting receiving date and time{" "}
                          </h5>
                          <div className="row mt-3">
                            <Form onSubmit={handelTimeSubmit}>
                              <div className="col-12 col-md-8 px-3">
                                <label
                                  htmlFor="datetime-picker"
                                  style={{
                                    display: "block",
                                    marginBottom: "5px",
                                    color: "#d6d8db",
                                  }}
                                >
                                  Select Date and Time
                                </label>
                                <input
                                  type="datetime-local"
                                  id="datetime-picker"
                                  value={startTime.toISOString().slice(0, 16)} // Format as "YYYY-MM-DDTHH:mm"
                                  min={startMinDate.toISOString().slice(0, 16)} // Minimum date/time restriction
                                  onChange={(e) =>
                                    setStartTime(new Date(e.target.value))
                                  } // Update state on change
                                  style={{
                                    width: "100%",
                                    padding: "12px",
                                    border: "1px solid #FFAD00",
                                    borderRadius: "5px",
                                    backgroundColor: "black",
                                    color: "#FFAD00",
                                    fontSize: "16px",
                                    boxSizing: "border-box",
                                    outline: "none",
                                    transition: "border-color 0.3s",
                                  }}
                                  onFocus={(e) =>
                                    (e.target.style.borderColor = "#FFAD00")
                                  }
                                  onBlur={(e) =>
                                    (e.target.style.borderColor = "#d6d8db")
                                  }
                                  disabled={greeting}
                                />
                                {/* <LocalizationProvider
                                  dateAdapter={AdapterDateFns}
                                >
                                  <DateTimePicker
                                    renderInput={(props) => (
                                      <TextField
                                        {...props}
                                        InputProps={{
                                          ...props.InputProps,
                                          sx: {
                                            color: "#FFAD00",
                                            "&.Mui-disabled": {
                                              color: "#FFAD00 !important",
                                            },
                                            
                                            
                                          },
                                        }}
                                        sx={{
                                          ".Mui-disabled": {
                                            color: "#FFAD00 !important",
                                          },
                                        }}
                                      />
                                    )}
                                    value={
                                      greeting?.request_time
                                        ? greeting?.request_time
                                        : startTime
                                    }
                                    minDate={startMinDate}
                                    onChange={(getStartTime) => {
                                      setStartTime(getStartTime);
                                    }}
                                    // disabled={greeting}
                                  />
                                </LocalizationProvider> */}
                              </div>
                              <div className="col-12 col-md-8 p-3">
                                <div className="mb-1">
                                  <label
                                    htmlFor="purpose"
                                    style={{
                                      display: "block",
                                      marginBottom: "5px",
                                      marginTop: "10px",
                                      color: "#d6d8db",
                                    }}
                                  >
                                    Greeting Purpose
                                  </label>
                                  <select
                                    onChange={handleInput}
                                    name="purpose"
                                    className="form-control input-bg text-warning border-warning w-100"
                                    value={inputData.purpose}
                                    style={{
                                      color: "#FFAD00",
                                      backgroundColor: "black",
                                    }}
                                    disabled={greeting}
                                  >
                                    <option
                                      className="text-warning input-select-bg"
                                      value=""
                                    >
                                      Select Purpose
                                    </option>
                                    {purposeList.map((purpose, index) => (
                                      <option
                                        key={purpose.greeting_type}
                                        style={{ color: "black !important" }}
                                        value={purpose.greeting_type}
                                      >
                                        {purpose.greeting_type}
                                      </option>
                                    ))}
                                  </select>
                                </div>{" "}
                                <small className="text-danger   ">
                                  {inputData.purpose ? <></> : choosePurpose}
                                </small>
                                {/* {inputData?.purpose && (
                                  <div className="mb-1">
                                    <label
                                      htmlFor="greeting_text"
                                      style={{ display: "block", marginBottom: "5px", marginTop:"10px", color: "#d6d8db" }}
                                    >
                                      Wish box
                                    </label>
                                    <select
                                      onChange={handleInput}
                                      name="greeting_text"
                                      className="form-control input-bg text-warning border-warning w-100"
                                      value={inputData?.greeting_text}
                                      disabled={greeting}
                                      style={{
                                        color: "#FFAD00",
                                        backgroundColor: "black",
                                      }}
                                    >
                                      <option
                                        className="text-warning input-select-bg"
                                        value=""
                                      >
                                        Select Wish
                                      </option>
                                      {greetingTextTypeList?.map(
                                        (item, index) => (
                                          <option
                                            key={index}
                                            style={{
                                              color: "black !important",
                                            }}
                                            value={item}
                                          >
                                            {item}
                                          </option>
                                        )
                                      )}
                                      {greeting && (
                                        <option
                                          style={{ color: "black !important" }}
                                          value={inputData?.greeting_text}
                                        >
                                          {inputData?.greeting_text}
                                        </option>
                                      )}
                                    </select>
                                  </div>
                                )}
                                <small className="text-danger   ">
                                  {inputData?.greetingTextMsg ? (
                                    <></>
                                  ) : (
                                    greetingTextMsg
                                  )}
                                </small> */}
                                <div className="mb-1">
                                  <label
                                    htmlFor="name"
                                    style={{
                                      display: "block",
                                      marginBottom: "5px",
                                      marginTop: "10px",
                                      color: "#d6d8db",
                                    }}
                                  >
                                    Name
                                  </label>
                                  <input
                                    type="text"
                                    name="name"
                                    className="form-control input-bg text-warning border-warning w-100"
                                    value={inputData?.name}
                                    onChange={handleInput}
                                    style={{
                                      color: "#FFAD00",
                                      backgroundColor: "black",
                                    }}
                                    disabled={greeting}
                                    placeholder="Enter full name"
                                    autoComplete="off"
                                  />
                                </div>
                                <small className="text-danger">
                                  {inputData.name ? <></> : chooseName}
                                </small>
                                {/* <div className="mb-1">
                                  <label
                                      htmlFor="name"
                                      style={{ display: "block", marginBottom: "5px", marginTop:"10px", color: "#d6d8db" }}
                                    >
                                       Comment
                                    </label>
                                  <input
                                    type="text"
                                    name="additional_message"
                                    className="form-control input-bg text-warning border-warning w-100"
                                    value={inputData.additional_message}
                                    onChange={handleInput}
                                    style={{
                                      color: "#FFAD00",
                                      backgroundColor: "black",
                                    }}
                                    disabled={greeting}
                                    placeholder="Enter comment"
                                    autoComplete="off"
                                  />
                                  </div> */}
                                {/* <div className="mb-1">
                                      <div style={{ display: "flex", gap: "20px", alignItems:"center", marginBottom: "5px", marginTop:"10px", color: "#d6d8db" }}>
                                        <span
                                          htmlFor="name"
                                          style={{ display: "inline-block",padding: "1px 5px", border: "1px solid transparent"}}
                                        >
                                          Comment
                                        </span>
                                        {suggestionWord && <span style={{ display: "inline-block", padding: "1px 5px", borderRadius:"5px", border:"1px solid #d6d8db", cursor:"pointer", boxSizing:"border-box" }} onClick={handleSuggestionClick} title="Press 'Tab' or click here">
                                          {suggestionWord}
                                        </span>}
                                      </div>
                                      <textarea name="additional_message" className="form-control" style={{
                                        height: '100px',
                                        color: "#FFAD00",
                                        backgroundColor: "black",
                                        resize: "none",
                                        borderColor:"#FFAD00"
                                      }} value={inputData.additional_message} onChange={handleCommentChange} onKeyDown={handleKeyDown} ref={textAreaRef} disabled={greeting}>
                                      </textarea>                            
                                    </div> */}
                                <div className="mb-1">
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "20px",
                                      alignItems: "center",
                                      marginBottom: "5px",
                                      marginTop: "10px",
                                      color: "#d6d8db",
                                    }}
                                  >
                                    <span
                                      htmlFor="name"
                                      style={{
                                        display: "inline-block",
                                        padding: "1px 5px",
                                        border: "1px solid transparent",
                                      }}
                                    >
                                      Comment
                                    </span>
                                  </div>
                                  <AutoSuggestionInput
                                    text={inputData.additional_message}
                                    setText={(newText) =>
                                      setInputData({ ...inputData, additional_message: newText })
                                    }
                                    disabled={greeting}
                                  />
                                </div>
                              </div>

                              {/* <div className="col-md-6 col-6 px-3">
                                    <button
                                      className="my-3 btn  greting-btn py-2 "
                                      type="submit"
                                    >
                                      Apply Now!
                                    </button>
                              </div> */}

                              {payStatus && (
                                <div className="col-md-6 col-6 px-3">
                                  {greeting ? (
                                    <button
                                      className="my-3 btn btn-success px-4 py-2"
                                      disabled
                                    >
                                      Applied{" "}
                                      <i className="fas fa-check-circle mx-1"></i>
                                    </button>
                                  ) : (
                                    <button
                                      className="my-3 btn  greting-btn py-2 "
                                      type="submit"
                                    >
                                      Apply Now!
                                    </button>
                                  )}
                                </div>
                              )}
                            </Form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <NodataAvailable className="mt-5" />
                  </>
                )}
              </div>
              <div className="col-md-4 abNStar mt-3">
                <StarProfileRightContent star_id={star_id} />
              </div>
            </div>
          </div>
        </>
      )}
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        event_id={greeting?.id}
        event_registration_id={greeting?.id}
        baseFee={countryBaseCost}
        fee={countryBaseCost}
        event_type="greeting"
        redirectTo={`starprofile/${star_id}/greeting`}
      />
    </>
  );
};

export default Greeting;
